exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-771f0742]{min-width:290px}.notes[data-v-771f0742]{max-width:210px;white-space:normal}", ""]);

// exports
